import type { NavigateFunction } from 'react-router-dom'
import type { QueryClient } from '@tanstack/react-query'
import type { UserFocus } from '@/hooks/use-focus-store'
import { invalidateEmployerOrganisationScopedQueries } from '@/utils/employer-query-invalidation'
import { getFocusRoute } from '@/utils/focus-routes'

const CROSS_FOCUS_QUERY_ROOTS = [
  'profile',
  'threads',
  'managed-organisations',
  'applications',
  'opportunities',
  'briefs',
] as const

export function invalidateFocusChangeQueries(
  queryClient: Pick<QueryClient, 'invalidateQueries'>,
): void {
  for (const key of CROSS_FOCUS_QUERY_ROOTS) {
    void queryClient.invalidateQueries({ queryKey: [key] })
  }
  invalidateEmployerOrganisationScopedQueries(queryClient)
}

export interface ApplyFocusChangeNavigationOptions {
  navigate: NavigateFunction
  searchParams: URLSearchParams
  nextFocus: string | null
  focusPayload: UserFocus
  onFocusChange?: (focus: UserFocus) => void
  onNavigateToPath?: (path: string) => void
  queryClient?: QueryClient
}

export function applyFocusChangeNavigation(opts: ApplyFocusChangeNavigationOptions): void {
  const {
    navigate,
    searchParams: _searchParams,
    nextFocus,
    focusPayload,
    onFocusChange,
    onNavigateToPath,
    queryClient,
  } = opts

  onFocusChange?.(focusPayload)

  if (queryClient) {
    invalidateFocusChangeQueries(queryClient)
  }

  const dashboardPath = getFocusRoute(nextFocus)
  if (onNavigateToPath) {
    onNavigateToPath(dashboardPath)
  } else {
    navigate(dashboardPath)
  }
}
